// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"35":"vendor_settings","50":"purchase_order","237":"analysis","691":"purchase_order_history","703":"low_sales"}[chunkId] + "." + {"35":"fe3e2445","50":"b65eb0eb","237":"b28af5ab","691":"34d58501","703":"3c0fcf9a"}[chunkId] + ".css";
};